module.exports = __webpack_public_path__ + "img/artificial-intelligence-in-supply-chain-management.1a83c2f6.png";